import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-flip-to-front",
  templateUrl: "./med-icon-flip-to-front.component.html",
})
export class MedIconFlipToFrontComponent extends SvgMixinComponent {}
